import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import Login from '../views/Login.vue'
import RegisterAccount from '../views/RegisterAccount.vue'
import VueCookies from 'vue-cookies'
import store from "../store"

Vue.use(VueRouter)

const routes = [
  {
    path: '/Account',
    name: 'home',
    component: HomeView,
    meta: { requiresLogin: true }
  },
  {
    path: '/Login',
    name: 'login',
    component: Login
  },
  {
    path: '/RegisterAccount',
    name: 'RegisterAccount',
    component: RegisterAccount
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  meta: { requiresLogin: false }
})

router.beforeEach((to, from, next) => {
  if(to.name == from.name){
    if(store.state.TokenState.accessToken == null && store.state.TokenState.refreshToken == null){
      next("/Login")
    }
    return
  }
  console.log(store.state.TokenState)
  if (to.matched.some(record => record.meta.requiresLogin) && store.state.TokenState.accessToken == null) {
    next("/Login")
  }
  next()
})
export default router
